import React from "react";
import { Link } from "react-router-dom";
import { Phone, Mail, MapPin, Clock } from "lucide-react";
import { SITE } from "../lib/site";

export default function Footer() {
  return (
    <footer
      data-testid="site-footer"
      className="bg-[#0F172A] text-white mt-0"
    >
      <div className="container-x py-16 lg:py-20 grid gap-12 lg:grid-cols-4">
        {/* Brand */}
        <div className="lg:col-span-1">
          <div className="flex items-center gap-3 mb-4">
            <img src="/voltis-mark.svg" alt="" aria-hidden="true" className="w-10 h-10" />
            <div className="font-heading font-extrabold text-xl text-white tracking-tight">
              VOLTIS<span className="text-[#EAB308]">.</span>
            </div>
          </div>
          <p className="text-slate-400 text-sm leading-relaxed">
            Électricien certifié pour le dépannage et l'installation électrique.
            Intervention rapide dans votre ville et alentours.
          </p>
        </div>

        {/* Services */}
        <div>
          <h4 className="font-heading text-sm uppercase tracking-widest text-[#EAB308] mb-5">
            Services
          </h4>
          <ul className="space-y-3 text-sm text-slate-300">
            <li><Link to="/depannage" className="hover:text-[#EAB308] transition-colors">Dépannage électrique</Link></li>
            <li><Link to="/depannage" className="hover:text-[#EAB308] transition-colors">Court-circuit / Disjoncteur</Link></li>
            <li><Link to="/installation" className="hover:text-[#EAB308] transition-colors">Installation complète</Link></li>
            <li><Link to="/installation" className="hover:text-[#EAB308] transition-colors">Rénovation & Mise aux normes</Link></li>
            <li><Link to="/installation" className="hover:text-[#EAB308] transition-colors">Tableau électrique</Link></li>
          </ul>
        </div>

        {/* Zones */}
        <div>
          <h4 className="font-heading text-sm uppercase tracking-widest text-[#EAB308] mb-5">
            Zone d'intervention
          </h4>
          <p className="text-sm text-slate-300 leading-relaxed">
            Nous intervenons rapidement dans <strong className="text-white">votre ville et alentours</strong>.
          </p>
          <Link to="/zone" className="mt-4 inline-flex items-center gap-2 text-sm text-[#EAB308] hover:text-yellow-300 transition-colors">
            Voir la carte →
          </Link>
        </div>

        {/* Contact */}
        <div>
          <h4 className="font-heading text-sm uppercase tracking-widest text-[#EAB308] mb-5">
            Contact
          </h4>
          <ul className="space-y-3 text-sm text-slate-300">
            <li className="flex items-start gap-3">
              <Phone className="w-4 h-4 text-[#EAB308] mt-0.5 shrink-0" />
              <a href={`tel:${SITE.phoneTel}`} className="hover:text-white">{SITE.phoneDisplay}</a>
            </li>
            <li className="flex items-start gap-3">
              <Mail className="w-4 h-4 text-[#EAB308] mt-0.5 shrink-0" />
              <a href={`mailto:${SITE.email}`} className="hover:text-white">{SITE.email}</a>
            </li>
            <li className="flex items-start gap-3">
              <MapPin className="w-4 h-4 text-[#EAB308] mt-0.5 shrink-0" />
              <span>Intervention dans votre secteur</span>
            </li>
            <li className="flex items-start gap-3">
              <Clock className="w-4 h-4 text-[#EAB308] mt-0.5 shrink-0" />
              <span>{SITE.hours}</span>
            </li>
          </ul>
        </div>
      </div>

      <div className="border-t border-white/10">
        <div className="container-x py-6 flex flex-col sm:flex-row justify-between items-center gap-3 text-xs text-slate-500">
          <p>© {new Date().getFullYear()} {SITE.brand}. Tous droits réservés.</p>
          <div className="flex gap-5">
            <Link to="/mentions-legales" className="hover:text-white">Mentions légales</Link>
            <Link to="/contact" className="hover:text-white">Contact</Link>
          </div>
        </div>
      </div>
    </footer>
  );
}
